const key = userId => `amposter:in-app-notifications:${userId}`;

export const inAppNotificationsEnabled = userId => {
  if (!userId) return true;
  try { return localStorage.getItem(key(userId)) !== 'false'; }
  catch { return true; }
};

export const setInAppNotificationsEnabled = (userId, enabled) => {
  if (!userId) return;
  localStorage.setItem(key(userId), String(Boolean(enabled)));
  window.dispatchEvent(new CustomEvent('amposter:in-app-notifications-changed', { detail: { userId, enabled: Boolean(enabled) } }));
};
